import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getFaqs } from "store/actions";

export default function Faqcenterartist() {
  let dispatch = useDispatch();
  const navigate = useNavigate();


  const { faqs } = useSelector((state) => state?.contentpage);
    // const faqs = useSelector((state) => [...(state?.contentpage?.faqs || [])].reverse());
  
  const { settings } = useSelector((state) => state?.Login);

  const [filter, setfilter] = useState({
    limit: 10,
    order: -1,
    page: 1,
    isMore: false,
    status: "active",
  });
  const [filterdFaq, setfilterdFaq] = useState();

  useEffect(() => {
    dispatch(getFaqs(filter));
  }, []);

    useEffect(() => {
      const data = faqs.filter((data) => data?.type == "artist")
      const sorttedData = data.sort((a, b) => a.orderid - b.orderid);
      console.log(sorttedData);
      setfilterdFaq(sorttedData)
      
    }, [faqs]);
  return (
    <section className="faq-center">
      <Container>
      <div className="faqHead">
      <div className="artgenTabNew"><button onClick={() => navigate('/user-faq')}> User </button><button onClick={() => navigate('/artist-faq')} className="active">Artist</button></div>
      {/* <h2>{settings?.faqData?.artistTittle}</h2> */}
    
        </div>
        <Row>
          <Col lg={12}>
              <div className="faqBox">
              <p className="text-start faqtext mb-4">Terpnash offer artists a global distribution of physical prints and digital artwork. 
Using our network of print shops for producing physical prints, international 
shipping costs and tariffs are virtually eliminated.  On our Digital Artwork 
marketplace, you can buy, sell, or trade Digital Artworks with other users. If you're
considering using Terpnash, you may have some questions. Here are some of the 
most frequently asked questions about Physical Print and Digital Artwork 
marketplaces.</p>
<div  className="accordion-faq accordionNew">
<Accordion  >
              {filterdFaq &&
              filterdFaq?.length > 0 &&
              filterdFaq.map((faqData, idx) => {
                return (
                  <>
                    {faqData?.type === "artist" ? (
                      
                      
                          <Accordion.Item key={idx} eventKey={idx}>
                            <Accordion.Header>
                              {faqData?.question}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: faqData?.answer,
                                }}
                              />
                            </Accordion.Body>
                          </Accordion.Item>
                       
                     
                    ) : null}
                  </>
                );
              })}
              </Accordion>
              </div>
              </div>
          </Col>
        </Row>

        <Row hidden>
          <Col lg={6} md={6} sm={12}>
            {settings?.faqData?.video?.link && (
              <div className="vedio-here position-relative">
                {settings?.faqData?.video?.link.search(".mp4") !== -1 ? (
                  <>
                    <video controls width="100%" height="100%">
                      <source
                        src={settings?.faqData?.artistvideo?.link}
                        type="video/mp4"
                      />
                    </video>
                  </>
                ) : (
                  <img
                    src={settings?.faqData?.artistvideo?.link}
                    alt=""
                    className="img-fluid"
                  />
                )}
              </div>
            )}
          </Col>

          <Col lg={6} md={6} sm={12}>
            {faqs &&
              faqs?.length > 0 &&
              faqs.map((faqData, idx) => {
                return (
                  <>
                    {faqData?.type == "artist" ? (
                      <div key={idx} className="accordion-faq">
                        <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey={idx}>
                            <Accordion.Header>
                              {faqData?.question}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: faqData?.answer,
                                }}
                              />
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    ) : null}
                  </>
                );
              })}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
